import type { RouterConfig } from '@nuxt/schema'
import { createMemoryHistory, createWebHistory } from 'vue-router'

export default <RouterConfig>{
  history: (base) => {
    if (import.meta.server) return createMemoryHistory(base)
    if (window.location.pathname === '/addin') return createMemoryHistory(base)
    return createWebHistory(base)
  },
}
